import { api } from "@/api/client";

export function requestPasswordReset(userId: string) {
  return api.post("/resets", { resetType: "Password", userId });
}

export function resetPassword(newPassword: string, resetToken?: string) {
  return api.post("/resets", { resetType: "Password", password: newPassword, resetToken });
}
